import styled from "styled-components";
import { TooltipDirection } from "./TooltipTypes";
import { SpacingValue } from "../ComponentProps";

import Box from "../Box";
import { getColor } from "../utils";

type Props = { direction: TooltipDirection; offset?: SpacingValue };

const TooltipTail = styled(Box).attrs<Props>(props => {
  const style = () => {
    const translateValue = props.offset ? `calc(-50% + ${props.offset}px)` : "-50%";
    const horizontalPosition = () => ({
      left: "50%",
      transform: `translateX(${translateValue})`,
    });
    const verticalPosition = () => ({
      top: "50%",
      transform: `translateY(${translateValue})`,
    });

    switch (props.direction) {
      case TooltipDirection.Top:
        return {
          borderBottomColor: getColor("modalOverlay"),
          top: "-16px",
          ...horizontalPosition(),
        };
      case TooltipDirection.Bottom:
        return {
          borderTopColor: getColor("modalOverlay"),
          bottom: "-16px",
          ...horizontalPosition(),
        };
      case TooltipDirection.Right:
        return {
          borderLeftColor: getColor("modalOverlay"),
          right: "-16px",
          ...verticalPosition(),
        };
      case TooltipDirection.Left:
        return {
          borderRightColor: getColor("modalOverlay"),
          left: "-16px",
          ...verticalPosition(),
        };
      default:
        return null;
    }
  };
  return {
    border: "solid 8px transparent",
    position: "absolute",
    style: style(),
  };
})<Props>`
  pointer-events: none;
`;

export default TooltipTail;
